// Module
var code = `<div class="transfer-money"> <component-heading></component-heading> <component-contacts-list></component-contacts-list> </div> `;
// Exports
export default code;